import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { IconBaseProps } from 'react-icons';
import { FiAlertCircle } from 'react-icons/fi';
import { useField } from '@unform/core';

import { Container, Error } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  containerStyle?: object;
  icon?: React.ComponentType<IconBaseProps>;
}

const Input: React.FC<InputProps> = ({
  name,
  containerStyle = {},
  icon: Icon,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, error, registerField } = useField(name);
  const [isFocused, setFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);

  // com useCallback a função será criada apenas um unica vez para parâmetros vazio [] ou
  // será recriada sempre que um parametro for alterado, seguindo o mesmo exemplo do useEffect
  const handleInputBlur = useCallback(() => {
    setFocused(false);

    setIsFilled(!!inputRef.current?.value); // Se o inputRef tiver valor retorna true , se não retorna false, tipo um "If ternário"
  }, []);

  const handleInputFocus = useCallback(() => {
    setFocused(true);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container
      style={containerStyle}
      isErrored={!!error}
      isFilled={isFilled}
      isFocused={isFocused}
      data-testid="input-container"
    >
      {Icon && <Icon size={20} />}
      <input
        onFocus={handleInputFocus} // Recebeu o Focus
        onBlur={handleInputBlur} // Perdeu o Focus
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
      />
      {error && (
        <Error title={error}>
          <FiAlertCircle color="#c53030" size={20} />
        </Error>
      )}
    </Container>
  );
};

export default Input;
